import React, { useState, useEffect } from 'react';
import pb from '../lib/pocketbase';
import { ZoomIn, X, ChevronLeft, ChevronRight } from 'lucide-react';
import './Gallery.css';

const Gallery = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const fetchGallery = async () => {
            try {
                // Fetch all gallery images, sorted by order or creation
                // Note: The user might have an 'ordre' field in 'galerie' collection based on previous chats
                // checking 'AdminGallery.js' (implied) or just fetch by list.
                // Assuming standard list for now.
                const records = await pb.collection('galerie').getList(1, 50, {
                    sort: 'ordre', // Trying sort by 'ordre', fallback to created if fails usually
                });

                const mappedImages = records.items.map(record => ({
                    id: record.id,
                    src: pb.files.getURL(record, record.image),
                    title: record.titre || ''
                }));

                setImages(mappedImages);
            } catch (err) {
                if (!err.isAbort) {
                    console.error("Error fetching gallery:", err);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchGallery();
    }, []);

    const openLightbox = (index) => {
        setCurrentIndex(index);
        setLightboxOpen(true);
        document.body.style.overflow = 'hidden'; // Prevent scrolling
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
        document.body.style.overflow = 'auto'; // Restore scrolling
    };

    const nextImage = (e) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev + 1) % images.length);
    };

    const prevImage = (e) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    if (!loading && images.length === 0) return null; // Don't show empty section

    return (
        <section className="gallery-section">
            <div className="container">
                <h2 className="text-center">Instants Gourmands</h2>
                <div className="divider" style={{ margin: '20px auto' }}></div>
                <p className="text-center" style={{ maxWidth: '600px', margin: '0 auto 40px', fontSize: '0.9rem', fontStyle: 'italic', color: '#666' }}>
                    Un aperçu de nos créations quotidiennes.
                </p>

                {loading ? (
                    <div className="text-center">Chargement...</div>
                ) : (
                    <div className="gallery-grid">
                        {images.map((img, index) => (
                            <div key={img.id} className="gallery-item" onClick={() => openLightbox(index)}>
                                <img src={img.src} alt={img.title} className="gallery-image" />
                                <div className="gallery-overlay">
                                    <ZoomIn className="gallery-icon" color="white" size={32} />
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Lightbox Modal */}
            {lightboxOpen && (
                <div className="lightbox-overlay" onClick={closeLightbox}>
                    <button className="lightbox-close" onClick={closeLightbox}>
                        <X size={30} />
                    </button>

                    <button className="lightbox-nav prev" onClick={prevImage}>
                        <ChevronLeft size={40} />
                    </button>

                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <img
                            src={images[currentIndex].src}
                            alt={images[currentIndex].title}
                            className="lightbox-image"
                        />
                        {images[currentIndex].title && (
                            <div className="lightbox-caption">{images[currentIndex].title}</div>
                        )}
                    </div>

                    <button className="lightbox-nav next" onClick={nextImage}>
                        <ChevronRight size={40} />
                    </button>
                </div>
            )}
        </section>
    );
};

export default Gallery;
